import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter } from "lucide-react";
import { Logo } from "./Logo";

const PRODUCT_LINKS = [
    { label: "Take the Survey", href: "/survey" },
    { label: "Meet Klair", href: "/#klair", external: false },
    { label: "Why Klareet", href: "/#why", external: false },
];

export function Footer() {
    const year = new Date().getFullYear();
    return (
        <footer
            className="relative z-10 border-t border-klareet-bor bg-klareet-NAVY"
            data-testid="site-footer"
        >
            <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 py-12 md:py-16 grid grid-cols-1 md:grid-cols-3 gap-10">
                {/* Brand column */}
                <div className="space-y-4">
                    <Link to="/" className="inline-flex">
                        <Logo className="h-10 w-auto" />
                    </Link>
                    <p className="text-sm text-klareet-MUT leading-relaxed max-w-xs">
                        Career clarity that actually works.
                    </p>
                    <p className="text-xs text-klareet-DIM font-mono">
                        Built by Flynaut · survey.klareet.com
                    </p>
                </div>

                {/* Product column */}
                <div className="space-y-4">
                    <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-klareet-T">
                        Product
                    </div>
                    <ul className="space-y-3 text-sm">
                        {PRODUCT_LINKS.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    className="text-klareet-MUT hover:text-klareet-T2 transition-colors"
                                    data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                >
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Contact column */}
                <div className="space-y-4">
                    <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-klareet-T">
                        Contact
                    </div>
                    <div data-testid="footer-contact" className="space-y-2">
                        <a
                            href="mailto:klair@klareet.com"
                            className="block text-base text-klareet-T2 hover:text-klareet-TEXT underline-offset-4 hover:underline transition-colors"
                            data-testid="footer-mailto"
                        >
                            klair@klareet.com
                        </a>
                        <p className="text-xs text-klareet-DIM font-mono">
                            Q3 2026 launch
                        </p>
                    </div>
                </div>
            </div>

            <div className="border-t border-klareet-bor">
                <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 py-6 flex flex-col md:flex-row items-center md:items-center justify-between gap-4 text-xs text-klareet-DIM">
                    <div className="font-mono order-2 md:order-1 text-center md:text-left">
                        © {year} Klareet. All rights reserved.
                    </div>
                    <div className="flex items-center gap-2 order-1 md:order-2">
                        <a
                            href="#"
                            aria-label="Klareet on LinkedIn"
                            aria-disabled="true"
                            className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-klareet-bor text-klareet-MUT hover:text-klareet-T2 hover:border-klareet-T transition-colors"
                            onClick={(e) => e.preventDefault()}
                            data-testid="footer-social-linkedin"
                        >
                            <Linkedin size={15} />
                        </a>
                        <a
                            href="#"
                            aria-label="Klareet on X"
                            aria-disabled="true"
                            className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-klareet-bor text-klareet-MUT hover:text-klareet-T2 hover:border-klareet-T transition-colors"
                            onClick={(e) => e.preventDefault()}
                            data-testid="footer-social-x"
                        >
                            <Twitter size={15} />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
